import React from "react";
import { InfoPanel, InlineCheck } from "./fields";
import { Button } from "../ui/button";
import { trackNoFundingClose } from "../../lib/api";

export const NO_FUNDING = "I do not presently have funding available.";
const HOME_URL = "https://familycourt.guide/research/";

export const goHome = () => {
  try {
    window.top.location.href = HOME_URL;
  } catch (e) {
    window.location.href = HOME_URL;
  }
};

export const NoFundingText = () => (
  <>
    <strong>Important Notice:</strong> We are unable to accept Legal Aid cases or undertake pro
    bono (free) work at this time. Our services are provided strictly on a private funded basis.
    If you require free legal assistance or Legal Aid funding, please consult the{" "}
    <a href="https://www.gov.uk/check-legal-aid" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-brand-black">Official UK Government Website</a>{" "}
    to find an eligible provider.
  </>
);

export const NoFundingOptions = ({ value, onChange, prefix }) => (
  <div className="space-y-3 border border-border bg-white p-4" data-testid={`${prefix}-nf-options`}>
    <InlineCheck
      checked={value === "secure"}
      onChange={(v) => onChange(v ? "secure" : "")}
      label="I am able to secure private funding (e.g., through personal savings, loans, or contributions from family and friends)."
      testid={`${prefix}-nf-secure`}
    />
    <InlineCheck
      checked={value === "none"}
      onChange={(v) => onChange(v ? "none" : "")}
      label="I currently have no funds available and require free or subsidized legal assistance (such as Legal Aid or pro bono services)."
      testid={`${prefix}-nf-none`}
    />
    {value === "none" && <FreeHelpList prefix={prefix} />}
  </div>
);

const FREE_HELP = [
  { name: "GOV.UK — Check if you can get legal aid", url: "https://www.gov.uk/check-legal-aid", note: "Find out if you qualify and search for a Legal Aid provider near you." },
  { name: "Citizens Advice", url: "https://www.citizensadvice.org.uk", note: "Free, confidential advice on family and legal problems." },
];

const FreeHelpList = ({ prefix }) => (
  <div className="border-t border-border pt-3" data-testid={`${prefix}-free-help`}>
    <p className="text-sm font-medium text-brand-black mb-2">Where to find free help</p>
    <ul className="space-y-2">
      {FREE_HELP.map((h) => (
        <li key={h.url} className="text-sm text-brand-darkgrey">
          <a href={h.url} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-brand-black hover:text-brand-gold">{h.name}</a>
          {" — "}{h.note}
        </li>
      ))}
    </ul>
  </div>
);

const closeAndGoHome = async (source) => {
  await Promise.race([trackNoFundingClose(source), new Promise((r) => setTimeout(r, 800))]);
  goHome();
};

export const CloseButton = ({ testid, source }) => (
  <Button onClick={() => closeAndGoHome(source)} data-testid={testid} className="bg-brand-black text-white hover:bg-brand-gold rounded-sm">
    Close
  </Button>
);

export const NoticePanel = ({ noFunding, testid }) => (
  <InfoPanel tone="grey" testid={testid}>
    {noFunding ? <NoFundingText /> : (
      <>
        The services offered through this form are privately funded. The practice does not undertake
        legal aid work through this service. Submitting an enquiry does not commit you to paying a fee.
      </>
    )}
  </InfoPanel>
);
